import { useCallback, useState } from 'react';
import { ArticlesListBody } from '@widgets/articles/articles-list-body';
import { ArticlesListHeader } from '@widgets/articles/articles-list-header';
import { useFilter } from '@features/common/index.ts';

export const ArticlesList = () => {
  const {
    selectedTags,
    onTagChange,
    search,
    onSearch,
    selectedAuthors,
    onAuthorChange,
    isFilterActive,
    onPartitionsChange,
    selectedPartitions,
    partitions,
    authors,
    tags,
    handleResetFilter,
    showFilterBar,
    setShowFilterBar,
  } = useFilter();

  const [titles, setTitles] = useState<Array<string>>([]);

  const onTitlesChange = useCallback((titles: string[]) => setTitles(titles), [setTitles]);

  return (
    <>
      <ArticlesListHeader
        isFilterActive={isFilterActive}
        titles={titles}
        showFilterBar={showFilterBar}
        setShowFilterBar={setShowFilterBar}
        clearFilterData={handleResetFilter}
        search={search}
        onSearch={onSearch}
      />
      <ArticlesListBody
        isFilterActive={isFilterActive}
        filterData={{
          tags,
          partitions,
          authors,
          handleResetFilter: handleResetFilter,
          isOpen: showFilterBar,
          selectedTags: selectedTags,
          hasResetButton: isFilterActive,
          onTagChange: onTagChange,
          selectedPartitions: selectedPartitions,
          onPartitionChange: (id) => onPartitionsChange([id]),
          selectedAuthors: selectedAuthors,
          onAuthorChange: onAuthorChange,
        }}
        onTitlesChange={onTitlesChange}
        search={search}
      />
    </>
  );
};
